// removed by extract-text-webpack-plugin
module.exports = {"voucher":"LSNkdwG7B7EN-B77zLqUe","tabs":"_2AlSicu82l6X_jHfG1oz4C","tab":"_1BTPiigc6vGW2S2-lPi3iL","active":"_1sVlDQe5ndatalDTCkSVff","tabContent":"_3kh6lb6WGoIXudqnFDXWKB","vSection":"_1fMx_zPkgioV37MHg7YEE5","lists":"_2hoDsQ1xVHhGDsqYhT2AYt","PCard":"_2f8lUbGf9Qb_zfmvGwfec_","nodata":"_1PdTUqedpjhARnUO0P4VJH","voucherItem":"_23-9q-sZ-iUqf_oHZesIP"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/ManagePromotion/ManagePromotion.scss
// module id = 455
// module chunks = 0